import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import * as globalAdd from '../../../connectionString';

@Injectable()
export class HaUpdatesService {
  constructor(private http: HttpClient) { }

  getHABuildDetailList() {
    return this.http.get(globalAdd.Paneladdress + 'api/HA/Build/haBuildList');
  }

  shareBuildWithDoctors(buildId: string,doctorsList: string) {
    return this.http.post(globalAdd.Paneladdress + 'api/HA/Build/sendMailToUsers', { buildId: buildId, text: doctorsList });
  }

}
